/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { TreeItem } from "@mui/x-tree-view/TreeItem";
import { Grid } from "@mui/material";

const SimplicityTreeItem = (props) => {
    const item = props.item;

    const label = (
        <Grid
            container
            spacing={1}
            direction='row'
            alignItems='center'
            wrap='nowrap'
            sx={{
                overflow: "hidden",
                textOverflow: "ellipsis",
            }}
        >
            <Grid item>{item ? item.nav_title : ""}</Grid>
        </Grid>
    );

    return (
        // <div style={{ paddingTop: '0.1em', paddingBottom: '0.3em', border: '1px solid red' }}>
        <div style={{ paddingTop: "0.1em", paddingBottom: "0.3em" }}>
            {item && (
                <TreeItem nodeId={`${item.guid}`} label={label}>
                    {item &&
                        item.children &&
                        item.children.map((child, index) => <SimplicityTreeItem key={index} item={child} />)}
                </TreeItem>
            )}
        </div>
    );
};

export default SimplicityTreeItem;
